module.exports = __webpack_public_path__ + "static/media/MyTasksInProgress.5aabfacc.svg";